import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-upload-meta-data.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasUploadMetaDataDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasUploadMetaDataEntity = useAppSelector(state => state.aidasUploadMetaData.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasUploadMetaDataDetailsHeading">AidasUploadMetaData</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasUploadMetaDataEntity.id}</dd>
          <dt>
            <span id="name">Name</span>
          </dt>
          <dd>{aidasUploadMetaDataEntity.name}</dd>
          <dt>
            <span id="value">Value</span>
          </dt>
          <dd>{aidasUploadMetaDataEntity.value}</dd>
          <dt>Aidas Upload</dt>
          <dd>{aidasUploadMetaDataEntity.aidasUpload ? aidasUploadMetaDataEntity.aidasUpload.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-upload-meta-data" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-upload-meta-data/${aidasUploadMetaDataEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasUploadMetaDataDetail;
